import { settingsTexts } from 'consts/text';
import { LabelMapper, MealProviderType } from 'types';

export const mealProviderTypeLabels: LabelMapper<MealProviderType> = {
    CATERING: settingsTexts.settlements.meals.formLabels.catering,
    OWN_KITCHEN: settingsTexts.settlements.meals.formLabels.ownKitchen,
};
